
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.727 6.857c-1.804 0-3.272-1.538-3.272-3.428V0H4.09C1.832 0 0 1.919 0 4.286v15.428C0 22.081 1.831 24 4.091 24h9.818c2.259 0 4.09-1.919 4.09-4.286L18 6.857h-3.273zm-9.817 12c-.452 0-.819-.384-.819-.857 0-.474.367-.858.819-.858.452 0 .818.384.818.858 0 .473-.366.857-.818.857zm0-3.429c-.452 0-.819-.383-.819-.857 0-.473.367-.857.819-.857.452 0 .818.383.818.857s-.366.857-.818.857zm0-3.428c-.452 0-.819-.384-.819-.857 0-.474.367-.857.819-.857.452 0 .818.383.818.857 0 .473-.366.857-.818.857zm8.182 6.856H7.364c-.452 0-.818-.383-.818-.857s.366-.857.818-.857h5.728c.452 0 .818.383.818.857s-.366.857-.818.857zm0-3.428H7.364c-.452 0-.818-.383-.818-.857s.366-.857.818-.857h5.728c.452 0 .818.383.818.857s-.366.857-.818.857zm0-3.429H7.364c-.452 0-.818-.383-.818-.857 0-.473.366-.857.818-.857h5.728c.452 0 .818.384.818.857 0 .474-.366.857-.818.857z","fill":"#029ADB"}})])
          )
        }
      }
    